import { ExternalLinkIcon } from 'lucide-react'

import { assets } from '@/ui/assets'
import { ExternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { Panel } from '@/ui/atoms/panel/Panel'
import { links } from '@/ui/constants/links'

export function EarnPointsBanner({ pointsSeason }: { pointsSeason: number }) {
  return (
    <Panel spacing="none" variant="secondary" className="relative isolate flex h-fit flex-col">
      <img src={assets.points.guestModePanelBg} className="absolute top-0 left-0 w-full" />
      <div className="flex flex-col gap-8 p-6 pt-[56%] text-center">
        <div className="flex flex-col gap-4">
          <div className="typography-heading-3 text-primary-inverse">Earn Points</div>
          <div className="typography-body-3 text-tertiary">
            Complete missions. Earn points. Climb the ranks. Unlock limited-time rewards before season {pointsSeason}{' '}
            ends. Spark your way to the top.
          </div>
        </div>
        <ExternalLinkButton to={links.docs.points} variant="secondary" size="l" className="w-full">
          Learn more <ExternalLinkIcon className="icon-size-sm" />
        </ExternalLinkButton>
      </div>
    </Panel>
  )
}
